export enum AdditionalDocumentWorkflowStatus {
    Uploaded = 1,
    InReview = 2,
    Confirmed = 3,
    Rejected = 4,
}

export enum AdditionalDocumentUploadChannel {
    WalletMobile = 1,
    WalletWeb = 2,
    MerchantPortal = 3,
    Onboarding = 4,
}

export enum MalwareScanStatus {
    Pending = 1,
    Clean = 2,
    Infected = 3,
    Failed = 4,
}

export interface IndividualDocumentDecisionRequest {
    rowVersion: string;
    customerRejectionReason?: string | null;
}

export interface IndividualDocumentInternalNoteRequest {
    rowVersion: string;
    internalComplianceNote?: string | null;
}

export interface IndividualDocumentVisibilityRequest {
    rowVersion: string;
    isVisibleToCustomer: boolean;
}

export interface CreateIndividualDocumentRequest {
    individualId: number;
    documentTypeId: number;
    fileStorageId: string;
    originalFileName: string;
    mimeType: string;
    fileSizeBytes: number;
    uploadChannel: AdditionalDocumentUploadChannel;
    idempotencyKey?: string;
}

// Officer/Approver upload (TNPDEVAPPS-1658): CRM stores the file itself via the same base64
// convention as AddKycDocument, then creates the metadata record — no separate File Storage call
// from the portal (CRM never accepts binary content on CreateIndividualDocumentRequest directly).
export interface UploadIndividualDocumentRequest {
    individualId: number;
    documentTypeId: number;
    fileName: string;
    fileData: string;
    mimeType: string;
    idempotencyKey?: string;
}

export interface IndividualDocumentModel {
    id: number;
    individualId: number;
    relatedKycSubmissionId: number | null;
    documentTypeId: number | null;
    // CRM fills it for every row; for a legacy row (no documentTypeId) it is the old document type's name.
    documentTypeDisplayName: string;
    originalFileName: string;
    mimeType: string;
    fileSizeBytes: number | null;
    workflowStatus: AdditionalDocumentWorkflowStatus | null;
    uploadChannel: AdditionalDocumentUploadChannel | null;
    uploadStamp: string;
    uploadedBy: number;
    reviewStartedAt: string | null;
    reviewStartedBy: number | null;
    decisionAt: string | null;
    decisionBy: number | null;
    customerRejectionReason: string | null;
    internalComplianceNote: string | null;
    isVisibleToCustomer: boolean | null;
    malwareScanStatus: MalwareScanStatus | null;
    rowVersion: string | null;
}
